import { faAnchor, faBookmark, faChartBar, faChartLine, faChartPie, faClock, faCloud, faCloudArrowUp, faEnvelope, faEye, faFile, faGlobe, faHouse, faImage, faInfoCircle, faLink, faPaperPlane, faTableCellsLarge } from "@fortawesome/free-solid-svg-icons";

const iconMap = {
    faChartLine: faChartLine,
    faCloudArrowUp: faCloudArrowUp,
    faHouse: faHouse,
    faClock: faClock,
    faLink: faLink,
    faAnchor: faAnchor,
    faFile: faFile,
    faTableCellsLarge: faTableCellsLarge,
    faChartPie: faChartPie,
    faGlobe: faGlobe,
    faEnvelope: faEnvelope,
    faEye: faEye,
    faInfoCircle: faInfoCircle,
    faChartBar: faChartBar,
    faPaperPlane: faPaperPlane,
    faCloud: faCloud,
    faBookmark: faBookmark,
    faImage: faImage,
};

export default iconMap;